import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volkswagenventoonrent() {



const cardData = {
  keyword: "Volkswagen Vento On Rent",
  heading: "Lotus Cab: Volkswagen Vento On Rent in Pune",

  headingDescription:
    "Lotus Cab offers premium Volkswagen Vento on rent in Pune for airport transfers, corporate meetings, executive travel, and comfortable outstation trips. The Volkswagen Vento is known for its powerful engine, superior road grip, elegant sedan design, and smooth highway stability, making it ideal for both city and long-distance travel. Whether you need a professional airport drop, a stylish sedan for a business meeting, or a comfortable ride for family travel, our AC Vento taxis ensure a refined driving experience. Each vehicle is regularly serviced, thoroughly sanitized, and maintained for maximum passenger comfort. Our chauffeur-driven Vento service includes experienced, background-verified drivers trained in safe and professional driving standards. We provide transparent per-kilometer pricing with flexible one-way, round-trip, and hourly rental packages. With punctual pickup across Pune and easy online booking support, Lotus Cab ensures your Volkswagen Vento rental experience is reliable, executive, and completely stress-free.",

  top: "Top Places to Visit in Pune with Volkswagen Vento",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada stands as a symbol of Pune’s rich Maratha history and architectural grandeur. Visitors from across India explore this iconic fort to experience its historic gates, grand walls, and cultural significance. The Volkswagen Vento sedan offers a smooth and refined city driving experience, making sightseeing comfortable and elegant. Its powerful engine handles urban traffic efficiently. Ideal for corporate guests and family city tours. Lotus Cab ensures punctual and convenient travel to central Pune destinations."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a heritage landmark associated with India’s freedom movement. The serene gardens and museum displays attract tourists, school groups, and business visitors alike. A premium sedan like the Volkswagen Vento provides comfortable seating and smooth air-conditioned travel. Ideal for professional or executive outings. The vehicle’s stylish presence adds sophistication to business trips."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular weekend destination offering scenic hill views and historic charm. The drive requires stable and reliable performance, which the Vento sedan provides efficiently. Ideal for couples and small families. Smooth suspension ensures relaxed travel even on uneven roads."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "This temple is one of Pune’s most visited spiritual landmarks. Comfortable city travel is essential during peak hours. Volkswagen Vento provides AC comfort and smooth navigation through traffic."
    },
    {
      title: "Koregaon Park",
      description:
        "Koregaon Park is known for its premium cafes and business spaces. Executive sedan travel is ideal for this upscale area. Volkswagen Vento enhances professional travel experience."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa hill city offers scenic road trips. The Vento’s highway performance ensures a stable and comfortable long-distance drive."
    },
    {
      title: "Lonavala",
      description:
        "Popular weekend getaway via expressway. Smooth highway driving and excellent fuel efficiency make Vento ideal."
    },
    {
      title: "Pune Airport",
      description:
        "Timely airport transfers require reliable sedan service. Volkswagen Vento offers comfort and punctual travel."
    }
  ],

  services: [
    {
      name: "Volkswagen Vento On Rent in Pune",
      description:
        "Premium Volkswagen Vento rental in Pune designed for executive travel and comfortable city rides. Stylish sedan with powerful performance and AC interiors. Ideal for airport transfers, business meetings, and outstation trips. Chauffeur-driven service included with professional drivers. Transparent per-kilometer pricing ensures clarity. Flexible booking options available."
    },
    {
      name: "Vento Taxi Pune",
      description:
        "Reliable Vento taxi service in Pune for local and long-distance travel. Comfortable seating and smooth ride quality. Ideal for individuals, couples, and corporate clients. Clean and sanitized vehicle maintained. Experienced drivers assigned."
    },
    {
      name: "Vento for Outstation Pune",
      description:
        "Comfortable outstation sedan rental from Pune to major destinations. Excellent highway stability and fuel efficiency. Ideal for business trips and family tours. Professional drivers ensure safe travel."
    },
    {
      name: "Vento Airport Transfer Pune",
      description:
        "Timely airport pickup and drop service with AC Vento sedan. Spacious trunk space for luggage. Punctual and reliable travel guaranteed."
    },
    {
      name: "Affordable Vento Rental Pune",
      description:
        "Budget-friendly Vento rental with transparent pricing and no hidden charges. Ideal for daily travel and city rides."
    },
    {
      name: "Corporate Sedan Rental Pune",
      description:
        "Executive-level sedan rental for corporate meetings and business travel. Professional driver and polished vehicle presentation."
    },
    {
      name: "Chauffeur Driven Vento Pune",
      description:
        "Experienced, background-verified chauffeurs ensure safe and professional service. Smooth and stress-free travel."
    },
    {
      name: "Online Vento Booking Pune",
      description:
        "Easy online booking with instant confirmation and 24/7 customer support."
    }
  ],

  tableData: [
    ["Volkswagen Vento On Rent in Pune", "Vento Taxi Pune"],
    ["Vento for Outstation Pune", "Vento Airport Transfer Pune"],
    ["Affordable Vento Rental Pune", "Sedan Car on Rent Pune"],
    ["Vento Per Km Rate Pune", "AC Vento Taxi Pune"],
    ["Chauffeur Driven Vento Pune", "Vento Drop Service Pune"],
    ["Corporate Sedan Rental Pune", "Online Vento Booking Pune"],
    ["Executive Car Hire Pune", "Premium Sedan Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Executive Sedan Comfort",
      WhyChoosedescription:
        "Volkswagen Vento offers premium sedan comfort with powerful performance and smooth suspension ideal for city and highway travel."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Experienced, trained drivers ensure safe, punctual, and courteous service for every ride."
    },
    {
      WhyChooseheading: "Transparent Pricing Structure",
      WhyChoosedescription:
        "Clear per-km fare breakdown with no hidden charges or surprise billing."
    },
    {
      WhyChooseheading: "Corporate Travel Ready",
      WhyChoosedescription:
        "Ideal sedan choice for executive meetings and professional travel."
    },
    {
      WhyChooseheading: "Reliable Airport Transfers",
      WhyChoosedescription:
        "On-time airport pickup and drop service with luggage support."
    },
    {
      WhyChooseheading: "Well-Maintained Vehicles",
      WhyChoosedescription:
        "Regular servicing and sanitization ensure safety and hygiene."
    },
    {
      WhyChooseheading: "Flexible Trip Options",
      WhyChoosedescription:
        "One-way, round-trip, and hourly rental packages available."
    },
    {
      WhyChooseheading: "24/7 Booking Assistance",
      WhyChoosedescription:
        "Round-the-clock customer support for booking and travel coordination."
    }
  ]
};

const faqData = [
  { question: "Is Volkswagen Vento available for airport transfer?", answer: "Yes, AC Vento sedan available for Pune airport pickup and drop." },
  { question: "Is driver included in Vento rental?", answer: "Yes, professional chauffeur included with every booking." },
  { question: "Is Vento suitable for outstation travel?", answer: "Yes, smooth highway performance makes it ideal for long trips." },
  { question: "Is per km pricing transparent?", answer: "Yes, clear fare structure with no hidden charges." },
  { question: "Can I book online?", answer: "Yes, instant online booking available." },
  { question: "Is the vehicle AC?", answer: "Yes, fully air-conditioned sedan provided." },
  { question: "Is corporate booking available?", answer: "Yes, executive sedan service for businesses available." },
  { question: "Is vehicle sanitized?", answer: "Yes, regularly cleaned and maintained." },
  { question: "Is one-way booking possible?", answer: "Yes, one-way and round-trip options available." },
  { question: "Is customer support available 24/7?", answer: "Yes, round-the-clock assistance provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Joshi",
    feedback:
      "Booked Volkswagen Vento for corporate meeting. Very smooth ride and professional driver. Excellent experience with Lotus Cab.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Mehta",
    feedback:
      "Used Vento for airport transfer. Clean vehicle and punctual pickup. Highly recommended sedan service.",
    rating: 5
  },
  {
    id: 3,
    name: "Business Executive",
    feedback:
      "Premium sedan rental with transparent pricing and reliable service. Perfect for executive travel.",
    rating: 5
  }
];









































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volkswagen Vento On Rent in Pune",
  "image": "https://lotuscab.com/assets/images/volkswagen-vento-rent-pune.jpg", 
  "description": "Lotus Cab provides Volkswagen Vento on rent in Pune for airport transfers, outstation trips, corporate travel, and family journeys. Affordable AC sedan with chauffeur-driven service, per km rates, premium and executive car options, drop services, and convenient online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/volkswagen-vento-on-rent-pune"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Volkswagen Vento On Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Volkswagen Vento in Pune with Lotus Cab. AC sedan for outstation, airport, corporate & family trips. Chauffeur included. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Volkswagen Vento On Rent in Pune, Vento Taxi Pune, Vento for Outstation Pune, Vento Airport Transfer Pune, Affordable Vento Rental Pune, Sedan Car on Rent Pune, Vento Per Km Rate Pune, AC Vento Taxi Pune, Chauffeur Driven Vento Pune, Vento Drop Service Pune, Corporate Sedan Rental Pune, Online Vento Booking Pune, Executive Car Hire Pune, Premium Sedan Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Volkswagenventoonrent;